import {API_PRODUCT_SUBSCRIPTION_GROUP_NAME_LIST} from './urlConstants';
import {AxiosInstance, AxiosResponse} from 'axios';

export const SUBSCRIPTION_GROUP_TYPE = {
  ADD_ON: "ADD_ON",
  BASE: "BASE"
}

interface ISubscriptionGroup {
  groupId: string;
  baseSubsGroupId: string;
  groupName: string;
  freeTrialDays: string;
  duplicateBenefitYN: boolean;
}

export const getSubscriptionGroupName = async (httpClient: AxiosInstance,props:{cpAppId : string}) => {
  const params = {cpAppId : props.cpAppId};

  const response: AxiosResponse<ISubscriptionGroup[]> = await httpClient.get(API_PRODUCT_SUBSCRIPTION_GROUP_NAME_LIST,{
    params
  })
  return response.data
}

export interface ICreateSubscriptionGroupProps {
  cpAppId: string;
  groupName: string;
  type: string,
  baseGroupId: string | null;
  subscriptionAddOn: Array<string> | null;
}

interface IErrorMessage {
  status: boolean,
  message: string
}

export function validateSubscriptionGroupName(subscriptionGroup: ICreateSubscriptionGroupProps): IErrorMessage {
  if (subscriptionGroup.type == SUBSCRIPTION_GROUP_TYPE.ADD_ON && !subscriptionGroup.baseGroupId) {
    return {
      status: false,
      message: "SUBSCRIPTION_GROUP_ADD_ON_EMPTY_BASE"
    }
  }
  return {
    status: true,
    message: ""
  }
}